// Bottom/content/NormalBottom.jsx
const NormalBottom = () => <div>Normal Bottom</div>;
export default NormalBottom;
